import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage12 from "../../../../assets/PDFViewerImages/PDFViewerImage12.jpg";
import PDFViewerImage13 from "../../../../assets/PDFViewerImages/PDFViewerImage13.jpg";

const Chapter13 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>

             {/* Chapter 13 */}
                <section id="section13" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter13Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph2}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph3}
                    </p>

                    <h3 className="drivers-handbook-subheading">
                         {language. chapter13Subheading1}

                    </h3>

                    <ul className="drivers-handbook-list">
                        <li>{language.chapter13List11}</li>
                        <li>{language.chapter13List12}</li>
                        <li>{language.chapter13List13}</li>
                        <li>{language.chapter13List14}</li>
                        <li>{language.chapter13List15}</li>
                        <li>{language.chapter13List16}</li>
                    </ul>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph4}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph5}

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph6}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph7}

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph8}

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph9}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage12} alt="Traffic Rules"/>
                    </div>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph10}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph11}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph12}
                    </p>

                    <h3 className="drivers-handbook-subheading">
                        {language.chapter13Subheading2}
                    </h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph13}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph14}

                    </p>
                    <h3 className="drivers-handbook-subheading">
                        {language.chapter13Subheading3}

                    </h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph15}

                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage13} alt="Traffic Rules"/>
                    </div>


                

                    <h3 className="drivers-handbook-subheading"> {language.chapter13Subheading4}
</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph16}



                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph17}


                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph18}

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph19}

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter13Paragraph20}


                    </p>
                </section>

        </>
    )

}

export default Chapter13;
